import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../ui/button';

interface DocumentTypeHeaderProps {
  onAddClick: () => void;
}

export default function DocumentTypeHeader({ onAddClick }: DocumentTypeHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold">Master Jenis Dokumen</h1>
        <p className="text-gray-500">Definisi jenis dokumen untuk semua modul</p>
      </div>
      <Button onClick={onAddClick} className="bg-blue-600 hover:bg-blue-700">
        <Plus className="w-4 h-4 mr-2" /> Tambah
      </Button>
    </div>
  );
}
